"use strict";

const PromotionBanner = () => {
    const init = () => {
        $(function() {
            var $promotionBannerVideo = $('.js-promotion-banner-video');
            if ($promotionBannerVideo.length > 0) {
                window.togglePlayVideo = function($this){
                    if($this.hasClass('playing')){
                        playPauseMuteVideo($promotionBannerVideo,"pause");
                    }else{
                        playPauseMuteVideo($promotionBannerVideo,"play");
                    }
                    $this.toggleClass('playing');
                }

                window.toggleMuteVideo = function($this){
                    if($this.hasClass('muted')){
                        playPauseMuteVideo($promotionBannerVideo,"unmute");
                    }else{
                        playPauseMuteVideo($promotionBannerVideo,"mute");
                    }
                    $this.toggleClass('muted');
                }
                
                setTimeout(function(){
                    $promotionBannerVideo.find('.js-play-toggle').trigger('click')
                }, 1000);

                function playPauseMuteVideo($bannerVideo, control){
                    var video;
    
                    video = $bannerVideo.find("video")[0];
                    if (video != null) {
                        if (control === "play"){
                            video.play();
                        } else if (control === "pause"){
                            video.pause();
                        } else if (control === "mute"){
                            video.muted = true;
                        } else if (control === "unmute"){
                            video.muted = false;
                        }
                    }
                }

                var lastWidth = 0;
                $(window).on('resize', function() {
                    $promotionBannerVideo.find('iframe, video').css('width', Math.max($promotionBannerVideo.outerWidth(), $promotionBannerVideo.outerHeight()*200/85)+'px');
                    $promotionBannerVideo.find('iframe, video').css('height', Math.max($promotionBannerVideo.outerHeight(), $promotionBannerVideo.outerWidth()*85/200)+'px');
                    if($(window).outerWidth() < 992){
                        $promotionBannerVideo.find('video[data-mobile-src]').css('width', Math.max($promotionBannerVideo.outerWidth(), $promotionBannerVideo.outerHeight()*768/1000)+'px');
                        $promotionBannerVideo.find('video[data-mobile-src]').css('height', Math.max($promotionBannerVideo.outerHeight(), $promotionBannerVideo.outerWidth()*1000/768)+'px');
                        if(lastWidth == 0 || lastWidth >= 992){
                            lastWidth = $(window).outerWidth();
                            $promotionBannerVideo.find('video[data-mobile-src]').each(function(){
                                $(this).find('source').attr('src', $(this).data('mobile-src'));
                                $(this)[0].load();
                                $(this)[0].play();
                            });
                        }
                    }else{
                        if(lastWidth < 992){
                            lastWidth = $(window).outerWidth();
                            $promotionBannerVideo.find('video[data-src]').each(function(){
                                $(this).find('source').attr('src', $(this).data('src'));
                                $(this)[0].load();
                                $(this)[0].play();
                            });
                        }
                    }
                });
            }

        });
    };

    return {
        init:init
    };
};

export default PromotionBanner;